module.exports = __webpack_public_path__ + "static/media/Cottonv7.0.0ca770c5.PNG";